import { Grid, Typography } from '@mui/material';
import _ from 'lodash';
import { memo, useCallback, useMemo, useState } from 'react';

/** TRANSLATION */
import { useTranslation } from 'react-i18next';

/** COMPONENT */
import InputCheckbox from 'component/Input/InputCheckbox';
import InputTextField from 'component/Input/InputTextField';

/** UTILS */
import { numberFormat, numberToCurrencyFormat } from 'utils/app.utils';
import useWindowSize from 'utils/useWindowSize';

/** STYLE */
import { styled } from '@mui/material/styles';
import { PaymentInterface } from 'api/counter/payment/payment-interface';
import {
  promotion,
  setPaymentChannelByKey,
  setSummeryByKey,
  setSummerySubByKey,
  setSummerySubTreatmentRightByKey,
  summery,
  summerySub,
  summerySubTreatmentRight,
  summeryTreatmentRight,
  valPayment,
  voucher,
} from 'app/slice/payment.slice';
import { swalWarning } from 'component/Alert/Swal';
import * as UseStyled from 'features/finance/payment/component/popupPayment/UseStyledFormPayment';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

export const CustomInputCheckbox = styled(InputCheckbox)(({ theme }) => ({
  marginRight: 0,
  alignItems: 'flex-start',
  paddingTop: 9,
  '.MuiCheckbox-root': {
    marginTop: -7,
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    '.MuiCheckbox-root': {
      flex: 1
    },
    '.MuiFormControlLabel-label': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '100%',

    }
  },
}))

const initErrMsg = { OVER_MAX_PAID: '', OVER_BALANCE_PAID: '', }

type TreatmentListType = {
  treatments?: any
  readOnly?: boolean
  paymentChannelId: number
  patientTreatmentRightId?: number
  treatmentRight?: any
  menu: 'PAYMENT' | 'OVERDUE' | 'RETROSPECTIVE' | 'EDIT_PAYMENT'
}

function TreatmentList(props: TreatmentListType) {
  const { t } = useTranslation()
  const [width] = useWindowSize()
  const dispatch = useDispatch()
  const location = useLocation()
  const valSummery = useSelector(summery)
  const valSummerySub = useSelector(summerySub)
  const valSummeryTreatmentRight = useSelector(summeryTreatmentRight)
  const valSummerySubTreatmentRight = useSelector(summerySubTreatmentRight)
  const objPayment: PaymentInterface = useSelector(valPayment)
  const useVoucher = useSelector(voucher)
  const usePromotion = useSelector(promotion)
  const [errMsg, setErrMsg] = useState({ ...initErrMsg })

  // ✅ OPTIMIZED: Memoized utility function
  const clearErrMsg = useCallback(() => setErrMsg({ ...initErrMsg }), [])

  const [sum, setSum] = useState(0)

  // ✅ OPTIMIZED: Memoized price calculation
  const priceOutStanding = useMemo(() =>
    props?.treatments?.outStandingPayment?.overdueTotal || 0,
    [props?.treatments?.outStandingPayment?.overdueTotal]
  )

  // ✅ OPTIMIZED: Memoized calculation function
  const onCalWidthOutProNVoucher = useCallback(() => {
    const discountPromotion = _.sumBy(valSummeryTreatmentRight[8], (o: any) => o?.isCheck ? Number(o.value) : 0) || 0
    const discountVoucher = _.sumBy(valSummeryTreatmentRight[7], (o: any) => o?.isCheck ? Number(o.value) : 0) || 0
    return discountPromotion + discountVoucher
  }, [valSummeryTreatmentRight])

  // ✅ OPTIMIZED: Memoized value other calculation
  const handleValOther = useCallback((id: number, newIndex: number) => {
    const valSummery = Object.values(valSummerySub).map((item: any, index: number) => {
      let total = 0
      if (newIndex !== index) {
        item.map((item_2: any) => {
          if (item_2.id === id) {
            return total += item_2.value
          }
        })
      }
      return total
    })
    return valSummery.reduce((acc: any, curr: any) => acc + curr, 0)
  }, [valSummerySub])

  // ✅ OPTIMIZED: Memoized limit promotion calculation
  const handleValLimitPromotion = useCallback((sub: any) => {
    const foreignKey = props.paymentChannelId
    const newKey = foreignKey === 8 ? 'promotion' : 'voucher'
    const treatmentRight = props.treatmentRight
    const discount = onCalWidthOutProNVoucher()
    if (treatmentRight?.[`${newKey}PriceType`] === 'DISCOUNT') {
      const valueCurrent = sub?.reduce((acc: any, item: any) => acc + (item?.value || 0), 0);
      if (treatmentRight?.[`${newKey}PriceUnit`] === 'PERCENT') {
        return (((objPayment.totalPrice + priceOutStanding) * (treatmentRight?.[`${newKey}Price`] || 0)) / 100) - valueCurrent
      } else {
        return (treatmentRight?.[`${newKey}Price`] || 0) - valueCurrent
      }
    }
    return 0
  }, [props.paymentChannelId, props.treatmentRight, objPayment.totalPrice, priceOutStanding, onCalWidthOutProNVoucher])

  // ✅ OPTIMIZED: Memoized calculate handler
  const handleCalculate = useCallback((price: number, valueCalculate: any, type, id, balance: number) => {
    clearErrMsg()


    if (valueCalculate === '') valueCalculate = 0
    const foreignKey = props.paymentChannelId
    const index = _.findIndex(valSummerySub[foreignKey], { type: type, id: id })
    const patientTreatmentRightId = props?.patientTreatmentRightId

    if (patientTreatmentRightId) {
      // if (valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId][index].paidBalance <= 0) return

      const treatmentRight = props.treatmentRight
      let res = valSummeryTreatmentRight[foreignKey]
      if (res) res = res[patientTreatmentRightId]
      if (res.isCheck) {
        if (treatmentRight.isDivide === '1') {
          let sumTreatmentRight = _.sumBy(valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId].filter((treatmentRightByKey: any, i: number) => i !== index), 'value')
          sumTreatmentRight = sumTreatmentRight + parseFloat(valueCalculate)
          if (sumTreatmentRight > treatmentRight.balance || valueCalculate > treatmentRight.balance) return swalWarning(`ยอดเงินการใช้สิทธิ ${treatmentRight.treatmentRightName} ต้องไม่เกิน ${treatmentRight.balance} บาท`)
        }
      } else {
        valueCalculate = 0
      }

      const treatmentSub = valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId]
      const sub = treatmentSub[index]
      const selectSumTrSub: any[] = valSummerySubTreatmentRight[props.paymentChannelId][patientTreatmentRightId]

      const valOther = handleValOther(sub.id, props.paymentChannelId)
      const valLimit = (treatmentRight?.promotionName || treatmentRight?.voucherName) ? handleValLimitPromotion(treatmentSub.filter((item: any, num: number) => num !== index)) : sub.treatmentPrice - valOther

      let paidVal = 0
      _.map(valSummerySubTreatmentRight, (channel: any, j: number) => {
        for (const i in channel) {
          if (Object.prototype.hasOwnProperty.call(channel, i)) {
            const item = channel[i];
            if ((Number(props.paymentChannelId) !== Number(j)) && item[index] && item[index].isCheck)
              paidVal += item[index].value
            else if ((Number(props.paymentChannelId) === Number(j)) && (Number(patientTreatmentRightId) !== Number(i)) && item[index] && item[index].isCheck)
              paidVal += item[index].value

          }
        }
      })
      const numberOut = [5, 8, 7]

      _.map(valSummerySub, (channel: any, j: number) => {
        if (!numberOut.includes(Number(j)) && channel[index] && channel[index].isCheck) {
          paidVal += channel[index].value
        }
      })
      balance = sub.treatmentPrice - paidVal

      const maxValue = balance > valLimit ? valLimit : balance
      const value = parseFloat(valueCalculate) > maxValue ? maxValue : parseFloat(valueCalculate)
      dispatch(setSummerySubTreatmentRightByKey({
        key: foreignKey,
        keySub: index,
        patientTreatmentRightId: patientTreatmentRightId,
        value: {
          ...sub,
          value: value
        }
      }))

      dispatch(setSummeryByKey({ key: props.paymentChannelId, value: value }))
      dispatch(setSummerySubByKey({ key: props.paymentChannelId, keySub: index, value: { ...sub, value: valueCalculate } }))
    } else {


      const subChannel = valSummerySub[props.paymentChannelId]
      const sub = valSummerySub[props.paymentChannelId][index]

      if (props.paymentChannelId === 6) {
        dispatch(setPaymentChannelByKey({ key: 6, value: valueCalculate > 0 }))
      } else if (props.paymentChannelId === 1) {
        const currentVal = parseFloat(valueCalculate) > balance ? balance : parseFloat(valueCalculate)
        const filterCurrentVal = _.filter(valSummerySub[props.paymentChannelId], (sum, indexSum: number) => {
          if (indexSum !== index) return sum
        })
        const sumVal = _.sumBy(filterCurrentVal, 'value')
        dispatch(setSummeryByKey({ key: 1, value: sumVal + currentVal }))
      }


      valueCalculate = parseFloat(valueCalculate) > balance ? balance : parseFloat(valueCalculate)
      let sumPaid = _.sumBy(subChannel.filter((sc: any, i: number) => i !== index), 'value')
      sumPaid = sumPaid + valueCalculate
      dispatch(setSummeryByKey({ key: props.paymentChannelId, value: sumPaid }))
      dispatch(setSummerySubByKey({ key: props.paymentChannelId, keySub: index, value: { ...sub, value: valueCalculate } }))
    }
  }, [clearErrMsg, props.paymentChannelId, props.patientTreatmentRightId, props.treatmentRight, valSummeryTreatmentRight, valSummerySubTreatmentRight, valSummerySub, handleValOther, handleValLimitPromotion, dispatch])

  // ✅ OPTIMIZED: Memoized checkbox handler
  const handleCheckBox = useCallback((type, id) => {
    const foreignKey = props.paymentChannelId
    const patientTreatmentRightId = props?.patientTreatmentRightId

    const sourceKey = valSummerySub[foreignKey] ? _.findIndex(valSummerySub[foreignKey], { type: type, id: id }) : -1

    if (patientTreatmentRightId) {
      if (!valSummerySubTreatmentRight[foreignKey] || !valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId]) {
        return
      }

      const sourceKeyTr = _.findIndex(valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId], { type: type, id: id })
      if (sourceKeyTr < 0) {
        return
      }

      const sub = valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId][sourceKeyTr]
      if (!sub) {
        return
      }

      const isCheck = sub.isCheck ? false : true
      let disabled = sub.isDisabled
      const treatmentRight = props.treatmentRight
      let valueCalculate = 0
      let refundValue = 0
      if (treatmentRight.isDivide === '1') {
        if (isCheck) {
          disabled = false
        } else {
          disabled = true
        }
      } else {
        disabled = true
        if (isCheck) {
          const checkChecked = valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId].filter((patineTreatmentRightByKey: any, i: number) => i !== sourceKeyTr && patineTreatmentRightByKey.isCheck)
          const channel: any = valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId]

          const price = _.sumBy(channel, 'value')
          const sumPaidBalance = _.sumBy(channel, 'paidBalance')
          const subFromSummerySub = sourceKey >= 0 && valSummerySub[foreignKey] && valSummerySub[foreignKey][sourceKey] ? valSummerySub[foreignKey][sourceKey] : null
          const paidBalance: any = _.sumBy(channel, 'paidBalance')
          const newKey = foreignKey === 8 ? 'promotion' : 'voucher'

          if (!treatmentRight?.promotionName && !treatmentRight?.voucherName) {
            if (checkChecked.length > 0 && price >= treatmentRight.price) return true

            if (treatmentRight.unit === "BAHT") {
              if (paidBalance > (treatmentRight.price - price)) {
                if (price > 0) valueCalculate = treatmentRight.price - price
                else valueCalculate = treatmentRight.price
              } else
                valueCalculate = paidBalance
            } else {
              valueCalculate = paidBalance * (treatmentRight.price / 100)
            }

            valueCalculate = subFromSummerySub && valueCalculate > subFromSummerySub.paidBalance ? subFromSummerySub.paidBalance : valueCalculate
          } else {
            disabled = false
          }
        } else {
          disabled = true
        }
      }

      if (!isCheck) refundValue = sub.value



      if (valSummery)

      // for (const val of valSummery[foreignKey]) {

      // }




      // const sumPaidBalance = valSummery[foreignKey]
      // dispatch(setSummeryByKey({ key: foreignKey, value: props.treatments?.orderPaymentChannelTreatmentRight }))

      if (sourceKey >= 0) {
        dispatch(setSummerySubByKey({ key: foreignKey, keySub: sourceKey, value: { ...sub, isCheck: isCheck, value: sub.value + valueCalculate, paidBalance: (sub.paidBalance - valueCalculate) + refundValue, isDisabled: disabled } }))
      }
      dispatch(setSummerySubTreatmentRightByKey({ key: foreignKey, keySub: sourceKeyTr, patientTreatmentRightId: patientTreatmentRightId, value: { ...sub, isCheck: isCheck, value: valueCalculate, paidBalance: (sub.paidBalance - valueCalculate) + refundValue, isDisabled: disabled } }))
    } else {
      if (sourceKey < 0 || !valSummerySub[foreignKey] || !valSummerySub[foreignKey][sourceKey]) {
        return
      }

      const sub = valSummerySub[foreignKey][sourceKey]
      if (!sub) {
        return
      }

      if (foreignKey === 6) {
        dispatch(setPaymentChannelByKey({ key: 6, value: sub.isCheck ? false : true }))
      }

      const sumPaid = valSummery[foreignKey] - (sub?.value || 0)


      dispatch(setSummeryByKey({ key: props.paymentChannelId, value: sumPaid }))

      dispatch(setSummerySubByKey({ key: foreignKey, keySub: sourceKey, value: { isCheck: sub.isCheck ? false : true, value: 0, treatmentPrice: sub.treatmentPrice, paidBalance: sub.paidBalance || 0, type: sub.type, id: sub.id, isDisabled: sub.isDisabled ? false : true } }))
    }
  }, [props.paymentChannelId, props.patientTreatmentRightId, props.treatmentRight, valSummerySubTreatmentRight, valSummerySub, valSummery, dispatch])

  // ✅ OPTIMIZED: Memoized checked state check
  const isChecked = useCallback((type, id, sub?: any) => {
    const foreignKey = props.paymentChannelId
    const patientTreatmentRightId = props?.patientTreatmentRightId
    if (patientTreatmentRightId) {
      if (valSummerySubTreatmentRight[foreignKey]) {
        if (valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId]) {
          const sourceKey = _.findIndex(valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId], { type: type, id: id })
          if (sourceKey >= 0 && valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId][sourceKey]) {
            return valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId][sourceKey]?.isCheck || false
          }
        }
      } return false
    } else {
      if (valSummerySub[foreignKey]) {
        const sourceKey = _.findIndex(valSummerySub[foreignKey], { type: type, id: id })
        if (sourceKey >= 0 && valSummerySub[foreignKey][sourceKey]) return valSummerySub[foreignKey][sourceKey]?.isCheck || false
        else return false
      }
    }
    return false
  }, [props.paymentChannelId, props.patientTreatmentRightId, valSummerySubTreatmentRight, valSummerySub])

  // ✅ OPTIMIZED: Memoized disabled state check
  const isDisabled = useCallback((type, id,) => {
    const foreignKey = props.paymentChannelId
    const patientTreatmentRightId = props?.patientTreatmentRightId
    if (patientTreatmentRightId) {
      if (valSummerySubTreatmentRight[foreignKey]) {
        if (valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId]) {
          const sourceKey = _.findIndex(valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId], { type: type, id: id })
          if (sourceKey >= 0 && valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId][sourceKey]) {
            return valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId][sourceKey]?.isDisabled || false
          }
        }
      } return true
    } else {
      if (valSummerySub[foreignKey]) {
        const sourceKey = _.findIndex(valSummerySub[foreignKey], { type: type, id: id })
        if (sourceKey >= 0 && valSummerySub[foreignKey][sourceKey]) return valSummerySub[foreignKey][sourceKey]?.isDisabled || false
        else return true
      }
    }
    return true
  }, [props.paymentChannelId, props.patientTreatmentRightId, valSummerySubTreatmentRight, valSummerySub])

  // ✅ OPTIMIZED: Memoized value getter
  const value = useCallback((type: string, id: any, sub?: any) => {
    const foreignKey = props.paymentChannelId
    const patientTreatmentRightId = props?.patientTreatmentRightId
    if (patientTreatmentRightId) {
      if (valSummerySubTreatmentRight[foreignKey]) {
        if (valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId]) {
          const sourceKey = _.findIndex(valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId], { type: type, id: id })
          if (sourceKey >= 0 && valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId][sourceKey]) {
            if (props.paymentChannelId === 7) {
              if (props.patientTreatmentRightId && valSummerySubTreatmentRight[props.paymentChannelId] && valSummerySubTreatmentRight[props.paymentChannelId][props.patientTreatmentRightId]) {
                return valSummerySubTreatmentRight[props.paymentChannelId][props.patientTreatmentRightId][sourceKey]?.value || 0
              }
              else return 0
            }

            const dataChanelFive = valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId]
            const newValue = _.find(dataChanelFive, (item: any, index: number) => {
              if (item?.isCheck && sub?.id === item?.id && sub?.type === item?.type) return item
            })
            return newValue?.value || 0
          }
        }
      } return 0
    } else {
      if (valSummerySub[foreignKey]) {
        const sourceKey = _.findIndex(valSummerySub[foreignKey], { type: type, id: id })
        if (sourceKey >= 0 && valSummerySub[foreignKey][sourceKey]) {
          return valSummerySub[foreignKey][sourceKey]?.value || 0
        }
      }
      return 0
    }
  }, [props.paymentChannelId, props.patientTreatmentRightId, valSummerySubTreatmentRight, valSummerySub])

  // ✅ OPTIMIZED: Memoized total price getter
  const totalPrice = useCallback((type, id) => {
    const foreignKey = props.paymentChannelId
    const patientTreatmentRightId = props?.patientTreatmentRightId
    if (patientTreatmentRightId) {

      if (valSummerySubTreatmentRight[foreignKey]) {
        if (valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId]) {
          // if (valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId][sourceKey]) {
          //   return valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId][sourceKey]?.treatmentPrice
          // }
          return _.find(valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId], { type: type, id: id })?.treatmentPrice || 0
        }
      } return 0
    } else {
      if (valSummerySub[foreignKey])
        return _.find(valSummerySub[foreignKey], { type: type, id: id })?.treatmentPrice || 0
      else return 0
    }
  }, [props.paymentChannelId, props.patientTreatmentRightId, valSummerySubTreatmentRight, valSummerySub])

  // ✅ OPTIMIZED: Memoized status check
  const checkStatus = useCallback(() => {
    const newTreatmentRight = valSummerySubTreatmentRight[props.paymentChannelId]
    let status = false
    let sum = 0
    _.map(newTreatmentRight, (item: any, index: number) => {
      status = item.isCheck === true
      sum += _.sumBy(item, 'paidBalance')
    })
    if (status) return status
    else return false
  }, [props.paymentChannelId, valSummerySubTreatmentRight])

  // ✅ OPTIMIZED: Memoized disabled checkbox check
  const checkDisCheckBox = useCallback((status: boolean, isCheck: boolean) => {
    if (props.paymentChannelId === 5) return false
    if ((props.paymentChannelId === 7 || props.paymentChannelId === 8) && props?.patientTreatmentRightId) {
      const sumPaidBalance = _.sumBy(valSummerySub[props.paymentChannelId], 'paidBalance')
      if (sumPaidBalance <= 0) {
        return true
      }
      return false
    }
    return status
  }, [props.paymentChannelId, props.patientTreatmentRightId, valSummerySub])

  // ✅ OPTIMIZED: Memoized disabled checkbox renderer
  const onRenderDisabledCheckBox = useCallback(() => {
    const paymentDisEdit = [8, 7]
    if (location?.pathname === '/payment-detail' && paymentDisEdit.includes(props.paymentChannelId)) {
      return true
    }
    return false
  }, [location?.pathname, props.paymentChannelId])

  // ✅ OPTIMIZED: Memoized combined treatments list
  const combinedTreatments = useMemo(() =>
    props.treatments?.order
      ? [...(props.treatments.order?.orderTreatments || []), ...(props.treatments.order?.orderProducts || [])]
      : props.treatments?.summeryTreatments || [],
    [props.treatments?.order, props.treatments?.summeryTreatments]
  )

  return (
    <>
      <Grid container spacing={2} className={'my-0'}>
        <Grid item sm={5} sx={{ flex: 1 }}>
          <Typography sx={{ fontWeight: 500 }}>{t('PAYMENT.FORM_PAYMENT.TABLE.TREATMENT')}</Typography>
        </Grid>
        <Grid item sm={3} className={`d-none d-md-block`}>
          <Typography className='text-center' sx={{ fontWeight: 500 }}>{t('PAYMENT.FORM_PAYMENT.TABLE.BALANCE')}</Typography>
        </Grid>
        <Grid item sm={4} className={'pr-2'} sx={{ minWidth: '100px' }}>
          <Typography className={`${width < 768 ? 'text-right' : 'text-center'}`} sx={{ fontWeight: 500 }}>{t('PAYMENT.FORM_PAYMENT.TABLE.PRICE')}</Typography>
        </Grid>
      </Grid>
      {_.map(combinedTreatments, (treatment, index) => {

        let type = ''
        let id: any = null

        if (treatment.tempOrderTreatmentId || treatment.orderTreatmentId) id = treatment.tempOrderTreatmentId || treatment.orderTreatmentId
        else if (treatment.tempOrderProductId || treatment.orderProductId) id = treatment.tempOrderProductId || treatment.orderProductId
        else id = parseInt(index) + 1

        const isTreatment = treatment.tempOrderTreatmentId || treatment.orderTreatmentId || treatment.operativeId ? true : false
        if (treatment.orderTreatmentId || treatment.orderProductId) type = isTreatment ? 'ORDER_TREATMENT' : 'ORDER_PRODUCT'
        else type = isTreatment ? 'TEMP_ORDER_TREATMENT' : 'TEMP_ORDER_PRODUCT'

        let sub: any = valSummerySub[props.paymentChannelId] ? _.find(valSummerySub[props.paymentChannelId], { type: type, id: id }) : null
        if (props.paymentChannelId === 7 && valSummerySubTreatmentRight[props.paymentChannelId] && useVoucher && valSummerySubTreatmentRight[props.paymentChannelId][useVoucher?.voucherListId]) {
          sub = _.find(valSummerySubTreatmentRight[props.paymentChannelId][useVoucher.voucherListId], { type: type, id: id })
        }


        const totalDcc = parseFloat(treatment.totalDcc) || 0
        const totalWithDcc = (treatment.total || 0) + totalDcc

        const sumPaidBalance = _.sumBy(valSummerySub[props.paymentChannelId], 'paidBalance')
        const sumTreatmentPrice = _.sumBy(valSummerySub[props.paymentChannelId], 'treatmentPrice')
        const newPaidBalance = sub?.paidBalance !== undefined ? sub?.paidBalance + (sub?.paymentOut || 0) : totalPrice(type, id) + (sub?.paymentOut || 0)

        let _isDisabled = checkDisCheckBox((sumPaidBalance === 0 && sumTreatmentPrice !== 0), isChecked(type, id, sub)) || treatment?.promotion?.some((item: any) => item?.promotionType === "EXTRA") || onRenderDisabledCheckBox()
        if (useVoucher !== undefined || usePromotion !== undefined) {
          const { itemsUsed } = props.paymentChannelId === 7 ? useVoucher : usePromotion || {}
          if (props.paymentChannelId === 7 || props.paymentChannelId === 8) {
            if (itemsUsed && itemsUsed?.length > 0) {
              const usablePrivile = itemsUsed.find((item: any) => {
                return (item.id === sub.id) && (item.type === sub.type)
              })
              if (!usablePrivile) {
                return false
              }
            }
            _isDisabled = true
          }
        }

        return (
          <Grid container spacing={2} className={'my-0'}>
            <Grid item sm={5} sx={{ flex: 1 }} className={'overflow-hidden'}>
              {!props.readOnly && (
                <CustomInputCheckbox
                  label={`${width < 768 ? `[${'01-01'}]` : ''} ${treatment.operativeName || treatment.itemName} (${numberToCurrencyFormat(totalWithDcc)})`}
                  checked={isChecked(type, id, sub)}
                  onChange={(e) => { handleCheckBox(type, id) }}
                  disabled={_isDisabled}
                // || newPaidBalance === 0 || newPaidBalance === '0'
                />
              ) || (
                  <Typography>{width < 768 ? `01-01 ${treatment.operativeName || treatment.itemName}` : treatment.operativeName || treatment.itemName}</Typography>
                )}
              <Typography className='d-md-none' sx={{ margin: '-8px 0 0 28px' }}>({numberFormat(totalWithDcc)})</Typography>
            </Grid>
            <Grid item sm={3} className={`d-none d-md-block`}>
              <Typography className='text-center' sx={{ paddingTop: !props.readOnly ? '10px' : 0 }}>{numberFormat(newPaidBalance)} {t('CURRENCY_CHANGE.TH')}</Typography>
            </Grid>
            <Grid item sm={4} className={`${!props.readOnly ? 'pr-2' : ''}`} sx={{ minWidth: '100px' }}>
              <UseStyled.CustomField className='justify-content-end'>
                {!props.readOnly && (
                  <>
                    {/* Input Paid by item in channel */}
                    <InputTextField
                      disabled={(props.menu === 'EDIT_PAYMENT' && [7, 8].includes(props.paymentChannelId)) || isDisabled(type, id) || treatment?.promotion?.some((item: any) => item?.promotionType === "EXTRA") || onRenderDisabledCheckBox()}
                      value={value(type, id, sub)}
                      type='number'
                      financeText
                      hideControl
                      onchange={(e) => {
                        handleCalculate(sub?.treatmentPrice, Number(String(e.target.value).replace(/[^0-9.]/g, '')), type, id, sub?.paidBalance !== undefined ? Number(sub?.paidBalance + sub?.value) : Number(totalPrice(type, id)))
                      }}
                      helperText={errMsg.OVER_MAX_PAID || ''}
                      inputTextAlign='right'
                    />
                    <Typography className='d-none d-md-block align-self-center ml-2'>{t('CURRENCY_CHANGE.TH')}</Typography>
                    {/* Input Paid by item in channel */}
                  </>
                ) || (
                    <Typography>{numberFormat(totalWithDcc)} {t('CURRENCY_CHANGE.TH')}</Typography>
                  )}
              </UseStyled.CustomField>
            </Grid>
          </Grid>
        )
      })}
    </>
  )
}

// ✅ OPTIMIZED: Memoized component to prevent unnecessary re-renders
export default memo(TreatmentList)
